import { AuthUser } from '@/modules/auth/models/AuthUser';
import { NavKey } from '@/modules/core/nav/constants/NavKey';
import { NavItem } from '@/modules/core/nav/models/NavItem';

export class NavOrderingService {
  order(navItems: NavItem[], authUser: AuthUser): NavItem[] {
    const customOrder: string[] = NavKey.getNavItemKeysOrder(authUser);

    return [...navItems].sort((a: NavItem, b: NavItem) => {
      const indexA: number = customOrder.indexOf(a.key);
      const indexB: number = customOrder.indexOf(b.key);

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      if (indexA !== -1) {
        return -1;
      }

      if (indexB !== -1) {
        return 1;
      }

      return 0;
    });
  }
}

export default new NavOrderingService();
